import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { Spinner } from '@/components';
import { Button } from '@/components/ui';

interface QueryResultsLoadMoreProps {
    isLoading: boolean;
    isLoadingMore: boolean;
    hasMore: boolean;
    onLoadMore: () => void;
}

export function QueryResultsLoadMore({
    isLoading,
    isLoadingMore,
    hasMore,
    onLoadMore,
}: QueryResultsLoadMoreProps) {
    const { t } = useTranslation(I18nNamespace.EVENTS);

    if (isLoading) {
        return (
            <div className="flex items-center gap-2 text-grey-300 text-sm">
                <Spinner size={16} />
                <span>{t('page.loading')}</span>
            </div>
        );
    }

    if (isLoadingMore) {
        return (
            <button
                disabled
                className="px-6 py-2.5 bg-grey-600 cursor-not-allowed text-white-100 text-sm font-medium rounded-lg flex items-center gap-2"
            >
                <Spinner size={16} />
                <span>{t('page.loading')}</span>
            </button>
        );
    }

    if (hasMore) {
        return (
            <Button variant="ghost" onClick={onLoadMore}>
                {t('page.loadMore')}
            </Button>
        );
    }

    return <></>;
}
